export { fromEntries, getValidHexColor } from '../utils.js';
